import { config } from '@/config';
export const MarcaService = {
    async getMarcaById(id) {
        const response = await fetch(`${config.API_URL}/api/Marca/${id}`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`Error al obtener la marca con id ${id}`);
        }
        const data = await response.json();
        return data;
    },
    async getAllMarcas() {
        const response = await fetch(`${config.API_URL}/api/Marca`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Error al obtener todas las marcas');
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de marcas en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
    async addMarca(marca) {
        const response = await fetch(`${config.API_URL}/api/Marca`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(marca),
        });
        if (!response.ok) {
            throw new Error('Error al agregar la marca');
        }
    },
    async updateMarca(id, marca) {
        const response = await fetch(`${config.API_URL}/api/Marca/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(marca),
        });
        if (!response.ok) {
            throw new Error('Error al actualizar la marca');
        }
    },
    async deleteMarca(id) {
        const response = await fetch(`${config.API_URL}/api/Marca/${id}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Error al eliminar la marca');
        }
    },
    async GetMarcaByRepuesto(repuestoID) {
        const response = await fetch(`${config.API_URL}/api/Marca/filter?repuestoId=${repuestoID}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener las marcas");
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de marcas en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
};
